import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-two-banner',
  templateUrl: './agency-two-banner.component.html',
  styleUrls: ['./agency-two-banner.component.scss']
})
export class AgencyTwoBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
